import { render } from "./TipSplitsRow.vue?vue&type=template&id=52b5070f"
import script from "./TipSplitsRow.vue?vue&type=script&lang=js"
export * from "./TipSplitsRow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__